function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#53AE94"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 12,
  fill: "url(#paint0_linear_374_1331)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
  fill: "#53AE94"
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_374_1331)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.45963 26.8637C2.94679 26.2716 2.47618 25.6443 2.05127 24.9863L11.0392 15.9997L2.05127 7.01222C2.47641 6.35465 2.94701 5.72762 3.45963 5.13571L14.3241 15.9997L3.45963 26.8637ZM0.86971 9.18227C0.517087 9.96333 0.226291 10.7709 0 11.5974L4.4025 15.9997L0 20.402C0.226442 21.2285 0.517233 22.036 0.86971 22.8171L7.68746 15.9997L0.86971 9.18227ZM16.0005 17.6787L5.13595 28.5427C5.72731 29.056 6.35443 29.5266 7.01255 29.951L16.0005 20.9635L24.9875 29.951C25.6456 29.5266 26.2727 29.056 26.864 28.5427L16.0005 17.6787ZM22.8182 31.1334L15.9995 24.3151L9.18179 31.1325C9.96301 31.4848 10.7705 31.7756 11.597 32.0022L15.9995 27.5999L20.403 32.0022C21.2294 31.7743 22.0369 31.4826 22.8182 31.1297V31.1334ZM16.0005 14.3235L26.864 3.45947C26.2724 2.94674 25.6453 2.47644 24.9875 2.05209L16.0005 11.0387L7.01255 2.05209C6.35465 2.47644 5.72756 2.94674 5.13595 3.45947L16.0005 14.3235ZM31.1303 22.8171C31.4829 22.0361 31.7737 21.2286 32 20.402L27.5975 15.9997L32 11.5974C31.7736 10.7706 31.4828 9.96279 31.1303 9.18136L24.3125 15.9997L31.1303 22.8171ZM20.9608 15.9997L29.9487 7.01222C29.5238 6.3545 29.0532 5.72745 28.5404 5.13571L17.6795 15.9997L28.544 26.8637C29.0569 26.2716 29.5275 25.6443 29.9524 24.9863L20.9608 15.9997ZM15.9995 7.6871L22.8182 0.869669C22.037 0.517354 21.2295 0.226581 20.403 0L15.9995 4.4023L11.597 0C10.7707 0.226986 9.96317 0.517749 9.18179 0.869669L15.9995 7.6871Z",
  fill: "white"
}));
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8295 13.7085V11.4465H22.8739V8H9.13797V11.4465H14.1829V13.7067C10.0828 13.8998 7 14.7325 7 15.73C7 16.7275 10.0843 17.5601 14.1829 17.7545V25H17.8307V17.7539C21.9234 17.5601 25 16.7281 25 15.7315C25 14.7349 21.9234 13.9029 17.8307 13.7091L17.8295 13.7085ZM17.8307 17.1402V17.1383C17.7278 17.145 17.199 17.1776 16.0216 17.1776C15.0803 17.1776 14.4181 17.1502 14.1847 17.1377V17.1408C10.5624 16.9762 7.85857 16.3294 7.85857 15.5554C7.85857 14.7814 10.5627 14.1355 14.1847 13.9707V16.4964C14.422 16.5131 15.1005 16.5541 16.0371 16.5541C17.162 16.5541 17.7275 16.5061 17.8313 16.4964V13.9707C21.4465 14.1358 24.1441 14.7833 24.1441 15.5545C24.1441 16.3257 21.4453 16.9735 17.8313 17.1386",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_374_1331",
  x1: 16,
  y1: 4,
  x2: 16,
  y2: 28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#127A5C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#127A5C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_374_1331"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));
function SvgSUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_1331)"
  }, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_374_1331",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _ref4), _ref5, _ref6), _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSUsdt);
export default __webpack_public_path__ + "static/media/sUSDT.c4ae7444e5cf79ea274297b9b5f87f7c.svg";
export { ForwardRef as ReactComponent };